<template>
    <breeze-validation-errors class="my-4 p-4 bg-white rounded-md" />

    <h1 class="text-lg sm:text-xl font-bold text-center text-white">Login to your account</h1>

    <div v-if="status" class="mb-4 font-medium text-sm text-white">
        {{ status }}
    </div>

    <form class="mt-8" @submit.prevent="submit">
        <div class="text-left">
            <breeze-label for="email" value="Email Address" class="font-bold text-white" />
            <breeze-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus autocomplete="username" />
        </div>

        <div class="text-left mt-4">
            <breeze-label for="password" value="Password" class="font-bold text-white" />
            <breeze-input id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="current-password" />
        </div>

        <div class="flex justify-between mt-8">
            <div>
                <label class="flex items-center">
                    <breeze-checkbox name="remember" v-model:checked="form.remember" />
                    <span class="ml-2 text-xs text-white">Remember me</span>
                </label>
            </div>

            <div>
                <inertia-link v-if="canResetPassword" :href="route('password.request')" class="text-xs text-white hover:underline">
                    Forgot your password?
                </inertia-link>
            </div>
        </div>

        <div class="w-full items-center mt-8">
            <button type="submit"
                class="w-full px-4 py-2 bg-white border border-transparent rounded-md font-bold text-green tracking-widest transition ease-in-out duration-150 hover:bg-green hover:text-white hover:border-white"
                :class="{ 'opacity-25': form.processing }"
                :disabled="form.processing"
            >
                Sign in
            </button>
        </div>
    </form>
</template>

<script>
    import BreezeButton from '@/Components/Button'
    import BreezeGuestLayout from "@/Layouts/Guest"
    import BreezeInput from '@/Components/Input'
    import BreezeCheckbox from '@/Components/Checkbox'
    import BreezeLabel from '@/Components/Label'
    import BreezeValidationErrors from '@/Components/ValidationErrors'

    export default {
        layout: BreezeGuestLayout,

        components: {
            BreezeButton,
            BreezeInput,
            BreezeCheckbox,
            BreezeLabel,
            BreezeValidationErrors
        },

        props: {
            canResetPassword: Boolean,
            status: String,
        },

        data() {
            return {
                form: this.$inertia.form({
                    email: '',
                    password: '',
                    remember: false
                })
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('login'), {
                    onFinish: () => this.form.reset('password'),
                })
            }
        }
    }
</script>
